import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/admin/users").then((r) => setUsers(r.data));
  }, []);
  return (
    <div data-testid="admin-users">
      <h2 className="font-display text-3xl font-semibold tracking-tight">Users</h2>
      <p className="text-sm text-muted-foreground mt-1">All accounts registered on Cyannect.</p>
      <div className="pf-card overflow-hidden mt-6">
        <table className="w-full text-sm">
          <thead className="bg-secondary/40 text-left text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="px-5 py-3">Name</th>
              <th className="px-5 py-3">Email</th>
              <th className="px-5 py-3">Role</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-border">
                <td className="px-5 py-3 font-medium">{u.name}</td>
                <td className="px-5 py-3">{u.email}</td>
                <td className="px-5 py-3">
                  <span className={`pf-chip ${u.role === "admin" ? "bg-[color:var(--pf-teal)] text-white" : u.role === "merchant" ? "bg-[color:var(--pf-mint)] text-black" : "bg-secondary"}`}>{u.role}</span>
                </td>
                <td className="px-5 py-3">{u.status}</td>
                <td className="px-5 py-3 text-xs text-muted-foreground">{(u.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
